import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class AddNpvrTask extends AbstractRequestTask {
  constructor({ event_id, event_alf_id, channel_id, payway_token, group_id }) {
    super();

    this.event_id = event_id;
    this.event_alf_id = event_alf_id;
    this.channel_id = channel_id;
    this.payway_token = payway_token;
    this.group_id = group_id;
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/recordings/v1/add`;
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    let newParamEventAlfId = {}

    if (this.event_alf_id && this.event_alf_id !== null) {
      newParamEventAlfId = {
        event_alf_id: this.event_alf_id
      };
    } else {
      newParamEventAlfId = {
        event_id: this.event_id
      };
    }

    const extraParams = {
      channel_id: this.channel_id,
      payway_token: this.payway_token,
      group_id: this.group_id,
    };

    // console.log('::::: parametros enviados', 'newParamEventAlfId::', {...newParamEventAlfId}, 'extraParams::', {...extraParams});
    return { ...params, ...extraParams, ...newParamEventAlfId };
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default AddNpvrTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/npvr/AddNpvrTask.js